<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">OrderCart</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<lib-order-cart [orderDetails]="orderDetails" [orderId]="orderId" (foodSubmitted)="onOrderCreated()"></lib-order-cart>
